<script>
  import { createPopper } from "@popperjs/core";
  import { onMount } from 'svelte';
  import Swal from 'sweetalert2';

  export let onEdit;  // Function passed from parent for editing
  export let onDelete; // Function passed from parent for deleting
  export let onObjetos; // Function passed from parent for fetching entities
  export let onPasswordChange; // Function for changing password
  export let closeDropdown; // Function to close dropdown
  export let entityName; // New prop for entity name
  export let canDelete = false; // New prop for canDelete
  export let canModify = false; // New prop for canModify
  
  // Debug logging
  $: if (entityName === 'role') {
      console.log('TableDropdown Debug for Roles:');
      console.log('- entityName:', entityName);
      console.log('- onObjetos exists:', !!onObjetos);
      console.log('- canModify:', canModify);
      console.log('- onObjetos function:', onObjetos);
  }

  let dropdownPopoverShow = false;
  let btnDropdownRef;
  let popoverDropdownRef;

  const toggleDropdown = (event) => {
    event.preventDefault();
    dropdownPopoverShow = !dropdownPopoverShow;
    if (dropdownPopoverShow) {
      createPopper(btnDropdownRef, popoverDropdownRef, {
        placement: "bottom-start",
      });
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownPopoverShow && !btnDropdownRef.contains(event.target) && !popoverDropdownRef.contains(event.target)) {
      dropdownPopoverShow = false;
    }
  };

  onMount(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  // Confirm delete with SweetAlert2
  async function confirmDelete() {
    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: "No podrás recuperar este banco después de eliminarlo.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminarlo!',
    });

    if (result.isConfirmed) {
      onDelete(); // Call the onDelete function passed from the parent
      closeDropdown(); // Close the dropdown
    }
  }
</script>

<div>
  <a
    class="text-sm text-blueGray-500 py-1 px-3"
    href="#uri"
    bind:this={btnDropdownRef}
    on:click={toggleDropdown}
    aria-haspopup="true"
    aria-expanded={dropdownPopoverShow}
  >
    <i class="fas fa-ellipsis-v"></i>
  </a>
  <div
    bind:this={popoverDropdownRef}
    class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48 {dropdownPopoverShow ? 'block':'hidden'}"
    style="z-index: 400;"
  >
    <a
      href="#uri" 
      on:click={(e) => { e.preventDefault(); onEdit(); closeDropdown(); }}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Editar
    </a>
    {#if entityName === 'users' && onPasswordChange}
      <a
        href="#uri" 
        on:click={(e) => { e.preventDefault(); onPasswordChange(); closeDropdown(); }}
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        Cambiar Contraseña
      </a>
    {/if}
    {#if canDelete}
      <hr class="border-t border-gray-200 my-2" />
      <a
        href="#uri" 
        on:click={(e) => { e.preventDefault(); confirmDelete(); }}
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-red-600 hover:bg-red-50"
      >
        Eliminar
      </a>
    {/if}
    {#if entityName === 'role' && onObjetos && canModify}
      <hr class="border-t border-gray-200 my-2" />
      <a
        href="#uri" 
        on:click={(e) => { e.preventDefault(); onObjetos(); closeDropdown(); }}
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        Objetos
      </a>
    {:else if entityName === 'role'}
      <!-- Debug info for roles -->
      <hr class="border-t border-gray-200 my-2" />
      <div class="text-xs text-gray-500 px-4 py-2">
        Debug: onObjetos={!!onObjetos}, canModify={canModify}
      </div>
    {/if}
  </div>
</div>